// @ts-nocheck


import { downloadRequestWithToken, fetchRequest } from './index';





import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

export const convertDataToServer = (
licensePlateChangeCalculation) => (
{
  ...licensePlateChangeCalculation,
  sum: convertFromRubToKop(licensePlateChangeCalculation.sum),
  months: licensePlateChangeCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
licensePlateChangeCalculation) => (
{
  ...licensePlateChangeCalculation,
  sum: convertFromKopToRub(licensePlateChangeCalculation.sum),
  months: licensePlateChangeCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
licensePlateChangeCalculationMonth) => (
{
  ...licensePlateChangeCalculationMonth,
  cost: convertFromRubToKop(licensePlateChangeCalculationMonth.cost)
});

export const convertDataFromServerMonth = (
licensePlateChangeCalculationMonth) => (
{
  ...licensePlateChangeCalculationMonth,
  cost: convertFromKopToRub(licensePlateChangeCalculationMonth.cost)
});

const basedUrl = 'licensePlateChangeCalculation';
const materialCalculation = new CommonApi(
  basedUrl,
  'расчет потребности в замене гос. номеров',
  convertDataToServer,
  convertDataFromServer
);

export const updateCalculations = async (
data) =>
{
  const updated = await fetchRequest.put(
    `/${basedUrl}/updateCalculations`,
    data
  );
  if (updated) return updated;
  throw new Error(`Не удалось отредактировать`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус расчет`);
};

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const print = async (vehiclePlanId, filter) => {
  const printed = await downloadRequestWithToken(`/${basedUrl}/print`, {
    ...filter,
    vehiclePlanId
  });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export default {
  ...materialCalculation,
  updateCalculations,
  changeStatus,
  calculate,
  print
};
